import {gql} from "@irati/utils/gql"
import fullUserV4 from "@irati/identity/services/fragments/fullUserV4"
import fullBusiness from "@irati/identity/services/fragments/fullBusiness"

const query = gql`
  query SSOLogin {
    login: ssoLoginV2 {
      user {
        ...fullUser
      }
      business {
        ...fullBusiness
      }
      accessToken
    }
  }
  ${fullUserV4}
  ${fullBusiness}
`

export const toString = query.loc.source.body

export default query
